/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum CriterionContextCodeEnum {
    BUNDLES = 'bundles',
    SETTLEMENTS = 'settlements',
    PERIODS = 'periods'
}
